<app-admin-header style="width: 100%;" [header]="header" [links]="links" [breadcrumbs]="breadcrumbs"
    [stats]="[]"></app-admin-header>
<app-skelitions [hidden]="!skelition" [value]="2"></app-skelitions>
<section class="container-fluid ms-main-bg py-5 mmmmmmm" *ngIf="!skelition">
    <div class="container ms-pg-structure">
        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">{{'Criterias' | translator}}</h4>
            </div>
            <app-project-step [step]="'Criteria'" [projectId]="projectId"></app-project-step>
        </div>
        <p-messages [(value)]="messages" [enableService]="false"></p-messages>
        <app-project-details-card *ngIf="channels && project && !skelition" [project]="project"
            [channels]="basicChannels" [branches]="selectedBranches"></app-project-details-card>

        <div class="white-box" *ngIf="stepCriteria == 1 && !(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null))">
            <div>
                <h4 class="semi-h-pg-4">{{"Main Criteria" | translator}}</h4>
            </div>
            <div class="grey-box">
                <form *ngIf="!(statusType == 'Approved' || statusType == 'Pending')" [formGroup]="criteriaForm">
                    <div class="row px-4">
                        <div class="col-md-4 col-12">
                            <div>
                                <h4 class="medium-h my-2">{{"Channel"  | translator}}</h4>
                                <div class="pppp-drop" style="margin: 1rem 0 2rem 0">
                                    <p-dropdown formControlName="channel" [placeholder]="'Select Channel' | translator"
                                        [options]="channels" optionLabel="name" optionValue="_id" [filter]="true"
                                        filterBy="name" [styleClass]="'ms-dropdown-pg-5'">
                                    </p-dropdown>
                                    <div style="color: red"
                                        *ngIf="criteriaForm.get('channel')?.invalid && (criteriaForm.get('channel')?.dirty || criteriaForm.get('channel')?.touched)">
                                        {{'Please select a channel.' | translator}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-8 col-12">
                            <div class="d-flex">
                                <div class="width-100">
                                    <h4 class="medium-h my-2">{{"Criteria"  | translator}}</h4>
                                    <div class="d-flex align-items-baseline">
                                        <div class="d-flex flex-column w-100">
                                            <input formControlName="criteria" type="text"
                                                class="form-control ms-input-white-pg-5" [placeholder]="'Criteria' | translator"
                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                            <div style="color: red;margin-top: -1rem;"
                                                *ngIf="criteriaForm.get('criteria')?.invalid && (criteriaForm.get('criteria')?.dirty || criteriaForm.get('criteria')?.touched)">
                                                {{'Please type a criteria.' | translator}}
                                            </div>
                                        </div>
                                        <div>
                                            <div (click)="createCriteria()" class="ms-plus-btn mx-2">
                                                <i class="pi pi-plus-circle"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="row px-4" *ngIf="criterias">
                    <ng-container *ngFor="let data of criterias;let i=index">
                        <div class="col-md-4 col-12">

                            <div class="d-flex">
                                <div class="width-100">
                                    <div class="white-box-check">
                                        <div class="d-flex align-items-center">
                                            <div class="d-flex">
                                                <div class="ms-check-box-font-400">
                                                    {{i + 1}}
                                                </div>
                                            </div>
                                            <div class="d-flex flex-wrap">
                                                <div class="ms-check-box-name">{{data.channel.name}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-8 col-12">
                            <div class="black-box-check w-100">
                                <div class="custom-flex-pg-3 w-100 33333">
                                    <div class="d-flex align-items-center mob-m-tb-pg-3 w-100">
                                        <div class="d-flex flex-wrap w-100">
                                            <div *ngIf="criteriaEditIndex != i" class="ms-check-box-name">
                                                {{data.criteria}}</div>
                                            <input *ngIf="criteriaEditIndex == i" [(ngModel)]="data.criteria"
                                                type="text" class="form-control ms-input-white-pg-5 w-100"
                                                placeholder="Criteria" id="exampleInputEmail1"
                                                aria-describedby="emailHelp">
                                        </div>
                                    </div>
                                    <div *ngIf="criteriaEditIndex != i && !(statusType == 'Approved' || statusType == 'Pending') " class="d-flex mob-m-tb-pg-3">
                                        <div class="circle-btn" (click)="confirmDelete(data._id)"><i
                                                class="fa fa-trash"></i></div>
                                        <div class="circle-btn" (click)="criteriaEditIndex = i"><i
                                                class="fa fa-pencil"></i></div>
                                    </div>
                                    <div *ngIf="criteriaEditIndex == i && !(statusType == 'Approved' || statusType == 'Pending') " class="d-flex mob-m-tb-pg-3">
                                        <div class="circle-btn" (click)="updateCriteria(data)"><i
                                                class="pi pi-check"></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div *ngIf="!(statusType == 'Approved' || statusType == 'Pending')" class="d-flex justify-content-center gap-1">
                <button (click)="stepCriteria = 2" class="next-btn">{{'Add Sub Criteria' | translator}} <i
                        class="pi pi-arrow-left mx-2"></i></button>
            </div>
        </div>

        <div class="white-box" *ngIf="stepCriteria == 2 && !(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null))">
            <div>
                <h4 class="semi-h-pg-4">{{"Sub Criteria"  | translator}}</h4>
            </div>
            <div class="grey-box">
                <div class="row pg-6-px-4">
                    <div class="col-md-4 col-12">
                        <div>
                            <h4 class="medium-h my-2">{{"Main Criteria"  | translator}}</h4>
                            <div class="d-flex align-items-baseline">
                                <select class="form-control ms-input-white-pg-5" [(ngModel)]="sub_criteria.criteriaId">
                                    <ng-container *ngFor="let item of criterias">
                                        <option [value]="item._id" [selected]="sub_criteria.criteriaId === item._id">
                                            {{item.criteria}} ({{item.channel.name}})
                                        </option>
                                    </ng-container>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8 col-12">
                        <div>
                            <div class="width-100">
                                <h4 class="medium-h my-2">{{"Sub Criteria"  | translator}}</h4>
                                <div class="d-flex align-items-baseline">
                                    <input type="text" class="form-control ms-input-white-pg-5"
                                        [(ngModel)]="sub_criteria.criteria" [placeholder]="'Sub Criteria' | translator"
                                        id="exampleInputEmail1" aria-describedby="emailHelp">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row pg-6-px-4">
                    <div class="col-md-8 col-12">
                        <div class="width-100">
                            <h4 class="medium-h my-2">{{"Factors"  | translator}}</h4>
                            <div class="d-flex align-items-baseline">
                                <input type="text" class="form-control ms-input-white-pg-5" [(ngModel)]="factor.factor"
                                    [placeholder]="'Factor' | translator" id="exampleInputEmail1" aria-describedby="emailHelp">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-12">
                        <div>
                            <div class="d-flex">
                                <div class="width-100">
                                    <h4 class="medium-h my-2">{{"Measuring Type"  | translator}}</h4>
                                    <div class="d-flex align-items-baseline">
                                        <p-dropdown [options]="measuringTypes" [ngClass]="'form-control ms-input-white-pg-5'" optionLabel="label" optionValue="value"
                                            [placeholder]="'Select Measuring Type' | translator" id="exampleInputEmail1"
                                            aria-describedby="emailHelp" [(ngModel)]="factor.measuringType"></p-dropdown>
                                        <div>
                                            <div class="ms-plus-btn mx-2" (click)="postSubCriteriaAndFactor()">
                                                <i class="pi pi-plus-circle"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center gap-1">
                <button (click)="stepCriteria = 1" class="next-btn">{{'Back' | translator}} <i
                        class="pi pi-arrow-right mx-2"></i></button>
            </div>
        </div>
        <div class="white-box">
            <div class="grey-box">
                <table>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">{{'Main Criterias' | translator}}</th>
                            <th scope="col">{{'Sub Criterias' | translator}}</th>
                            <th scope="col">{{'Factor' | translator}}</th>
                            <th scope="col">{{'Measuring Type' | translator}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let criteria of criterias; let criteriaIndex = index">
                            <ng-container *ngFor="let subCriteria of criteria['sub-criterias']; let subCriteriaIndex = index">
                                <tr *ngFor="let factor of subCriteria['factors']; let factorIndex = index">
                                    <td style="width:0px;" data-label=""><span class="ms-tabel-td-mob-mr">
                                            <div class="d-flex tab-num-border-white">
                                                <div>
                                                    <div class="ms-tabel-num-box">
                                                        {{ getRowIndex(criteriaIndex, subCriteriaIndex, factorIndex) }}
                                                    </div>
                                                </div>
                                            </div>
                                        </span></td>
                                    <td data-label="Main Criteria"><span class="ms-tabel-td-mob-mr">
                                            <div class="tabel-detail-box">{{criteria.criteria}}
                                                ({{criteria.channel.name}})</div>
                                        </span></td>
                                    <td data-label="Sub Criteria"><span class="ms-tabel-td-mob-mr">
                                            <div class="tabel-detail-box">{{subCriteria.criteria}}</div>
                                        </span></td>
                                    <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                            <div class="tabel-detail-box">{{factor?.factor}}</div>
                                        </span></td>
                                        <td data-label="Measuring Type"><span class="ms-tabel-td-mob-mr">
                                            <div class="tabel-detail-box">{{factor?.measuringType}}</div>
                                        </span></td>
                                </tr>

                                <tr *ngIf="subCriteria['factors']?.length < 1">
                                    <td data-label=""><span class="ms-tabel-td-mob-mr">
                                            <div class="d-flex tab-num-border-white">
                                                <div>
                                                    <div class="ms-tabel-num-box">
                                                        {{ getRowIndex(criteriaIndex, subCriteriaIndex) }}
                                                    </div>
                                                </div>
                                            </div>
                                        </span></td>
                                    <td data-label="Main Criteria"><span class="ms-tabel-td-mob-mr">
                                            <div class="tabel-detail-box">{{criteria.criteria}}
                                                ({{criteria.channel.name}})</div>
                                        </span></td>
                                    <td data-label="Sub Criteria"><span class="ms-tabel-td-mob-mr">
                                            <div class="tabel-detail-box">{{subCriteria.criteria}}</div>
                                        </span></td>
                                    <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                            <div class="tabel-detail-box">‎ </div>
                                        </span></td>
                                        <td data-label="Measuring Type"><span class="ms-tabel-td-mob-mr">
                                            <div class="tabel-detail-box">‎ </div>
                                        </span></td>
                                </tr>
                            </ng-container>
                            <tr *ngIf="criteria['sub-criterias']?.length < 1">
                                <td data-label=""><span class="ms-tabel-td-mob-mr">
                                        <div class="d-flex tab-num-border-white">
                                            <div>
                                                <div class="ms-tabel-num-box">
                                                    {{ getRowIndex(criteriaIndex, 0) }}
                                                </div>
                                            </div>
                                        </div>
                                    </span></td>
                                <td data-label="Main Criteria"><span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box">{{criteria.criteria}} ({{criteria.channel.name}})
                                        </div>
                                    </span></td>
                                <td data-label="Sub Criteria"><span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box">‎</div>
                                    </span></td>
                                <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box">‎ </div>
                                    </span></td>
                                    <td data-label="Measuring Type"><span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box">‎ </div>
                                    </span></td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
            <div *ngIf="!(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && (statusType == '' || statusType == 'Redo' || statusType == 'Change') " class="d-flex justify-content-end gap-1">
                <button class="next-btn" (click)="submitForApproval()" >{{'SubmitMS' | translator}}</button>
            </div>
        </div>
        <ng-container *ngIf="(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && statusType == 'Pending'">
            <div class="my-4 bg-comment-color mx-1">
                <h5 class="medium-h-v4 p-3">{{'Comments' | translator}}</h5>
                <input class="ms-input-textarea" type="textarea" 
                    [(ngModel)]="pmComment" placeholder="">
            </div>
            <div class="d-flex justify-content-center gap-1">
                <button (click)="redoStatus()" class="re-do-btn mx-2">{{'Redo' | translator}} <i
                        class="fa-solid fa-arrows-rotate mx-2"></i></button>
                <button (click)="approveStatus()" class="next-btn">{{'Approve' | translator}} <i
                        class="pi pi-check-circle mx-2"></i></button>
            </div>
        </ng-container>
        <ng-container *ngIf="statusType != ''">
            <div class="my-4 bg-comment-color mx-1" align="center">
                <h5 class="medium-h p-3" [ngClass]=" statusType == 'Approved' ? 'text-success' : (statusType == 'Change' ? '' : (statusType == 'Pending' ? '' : 'text-danger'))">
                    <ng-container *ngIf="statusType === 'Change' || statusType === 'Pending'; else defaultTemplate">
                        {{ 'Criterias' | translator }} {{ ('are in ' + statusType + ' State') | translator }}
                    </ng-container>
                    <ng-template #defaultTemplate>
                        {{ ('are in ' + statusType + ' State') | translator }} {{ (statusType == 'Approved') ?  ('Criterias' | translator) : '' }}
                    </ng-template>
                </h5>
                <h5 *ngIf="statusType == 'Redo' || statusType == 'Change'" class="medium-h p-3">{{ pmComment }}</h5>
            </div>
        </ng-container>
        <ng-container *ngIf="(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && statusType == 'Approved'">
            <div class="my-4 bg-comment-color mx-1">
                <h5 class="medium-h-v4 p-3">{{'Comments' | translator}}</h5>
                <input class="ms-input-textarea" type="textarea" 
                    [(ngModel)]="pmComment" placeholder="">
            </div>
            <div class="d-flex justify-content-center gap-1">
                <button (click)="requestChange()" class="next-btn">{{'Request Change' | translator}}</button>
            </div>
        </ng-container>
        <div class="d-flex justify-content-between">
            <button [routerLink]="'/ms/assign-weights/'+projectId" class="next-btn">{{'Back' | translator}} <i
                    class="pi pi-arrow-right mx-2"></i></button>
            <button [routerLink]="'/ms/factor/'+projectId" class="next-btn">{{'Next' | translator}} <i
                    class="pi pi-arrow-left mx-2"></i></button>
        </div>

    </div>
</section>

<p-confirmDialog [style]="{margin: '0rem 1rem'}"></p-confirmDialog>
<app-footer></app-footer>